import type { DataSourceKind } from '../realtime/contracts';

const SOURCE_NAMES = {
  MobileApp: 'Mobile App',
  MobileAppSms: 'Mobile App SMS',
  WebApp: 'Web App',
  GoogleEls: 'Google ELS',
  Aml: 'AML',
  AppleEed: 'Apple EED',
} as const satisfies Record<DataSourceKind, string>;

export function callDataSourceNames(sourceKinds: readonly DataSourceKind[]): string[] {
  return sourceKinds.map((kind) => SOURCE_NAMES[kind]);
}
